import { readAmplitudeProps, trackAmplitudeEvents } from "../../utils/events/amplitude";

export class WistiaAmplitude {
  constructor({ amplitudeProps, secondsPreviouslyWatched, videoDuration }) {
    const { eventName, eventProperties } = readAmplitudeProps(amplitudeProps);
    this.eventProperties = eventProperties;
    this.playVideoEventName = eventName;

    this.secondsPreviouslyWatched = secondsPreviouslyWatched;
    this.videoDuration = videoDuration;
    this.roundedVideoDuration = Math.floor(this.videoDuration);

    this.traceablePercentages = {
      90: {
        tracked: false,
        eventName: "video_90pct_viewed",
        track: ({ currentPercentage }) =>
          this.trackPercentage({ traceablePercentage: 90, videoPercentage: currentPercentage }),
      },
      50: {
        tracked: false,
        eventName: "video_half_viewed",
        track: ({ currentPercentage }) =>
          this.trackPercentage({ traceablePercentage: 50, videoPercentage: currentPercentage }),
      },
    };

    this.endVideoTraceablePercentages = {
      100: {
        tracked: false,
        eventName: "video_complete_viewed",
        track: () => this.endVideoTrackPercentage({ traceablePercentage: 100 }),
      },
    };
  }

  pendingPercentagesToTrack() {
    return Object.values(this.traceablePercentages).some(({ tracked }) => !tracked);
  }

  trackPlayVideo({ isResume = false } = {}) {
    trackAmplitudeEvents(this.playVideoEventName, {
      ...this.eventProperties,
      action: isResume ? "resume" : "start",
    });
  }

  trackPercentage({ traceablePercentage, videoPercentage }) {
    const trackPercentage = this.traceablePercentages[traceablePercentage];
    if (!trackPercentage) {
      return;
    }

    if (trackPercentage.tracked) {
      return;
    }

    this.traceablePercentages[traceablePercentage].tracked = true;

    trackAmplitudeEvents(trackPercentage.eventName, {
      ...this.eventProperties,
      video_total_duration_sec: this.roundedVideoDuration,
      video_time_seen_sec: Math.floor(this.roundedVideoDuration * videoPercentage),
    });
  }

  endVideoTrackPercentage({ traceablePercentage }) {
    const trackPercentage = this.endVideoTraceablePercentages[traceablePercentage];
    if (!trackPercentage) {
      return;
    }

    if (trackPercentage.tracked) {
      return;
    }

    this.endVideoTraceablePercentages[traceablePercentage].tracked = true;

    trackAmplitudeEvents(trackPercentage.eventName, {
      ...this.eventProperties,
      video_total_duration_sec: this.roundedVideoDuration,
    });
  }
}
